import React, { useEffect } from "react";
import "./index.scss";

const Icon = (props) => {

  const { id, name,size, source_type, source,className,custom_styles } = props;
  let svgPath = "";

  if (source_type == "url") {
    svgPath = `https://signdesk.in/company/${source}`;
  } else if(source_type == 'assets') {
    svgPath = require(`../../assets/${source}`);
  }

  return (
    <div className={size}>
      {svgPath?.length && (
        <img 
  src={svgPath} 
  className={`${source_type === 'url' ? '' : 'img__container'} ${custom_styles} ${className || ''} `} 
/>
      )}
    </div>
  );
};

export default Icon;
